import { useParams } from "react-router-dom";
import AppLoading from "components/AppLoading/AppLoading";
import { PageTool404 } from "./PageTool404";
import { Helmet } from "react-helmet-async";
import { PageToolProject } from "./PageToolProject";
import { PageToolViewOnly } from "./PageToolViewOnly";
import { isNonNullish } from "utils/isNonNullish";
import { ToolDataContextValue, ToolDataProvider } from "./ToolDataProvider";
import { useCallback } from "react";
import { DjangoClient } from "api/client/DjangoClient";

export const PageTool = () => {
  const _toolId = useParams<{ toolId: string }>().toolId;
  const toolId = Number(_toolId);

  const { data, isLoading, error, invalidateQuery } =
    DjangoClient.tool.get.useQuery(toolId);

  // Pass a function to children to allow them to invalidate the tool query
  const invalidateToolQuery = useCallback(
    () => invalidateQuery({ exact: true }),
    [invalidateQuery],
  );

  if (isLoading && data === undefined) {
    return <AppLoading />;
  }
  if (isNonNullish(error) || data === undefined) {
    return <PageTool404 />;
  }

  return (
    <ToolDataProvider
      tool={{
        ...data,
        tool_versions:
          data.tool_versions as ToolDataContextValue["tool"]["tool_versions"],
      }}
      invalidateToolQuery={invalidateToolQuery}
    >
      <Helmet>
        <title>{`${data.name}`}</title>
      </Helmet>
      {
        // if we don't see a project, assume this is view-only
        isNonNullish(data.project) ? <PageToolProject /> : <PageToolViewOnly />
      }
    </ToolDataProvider>
  );
};
